import router from "./router";
import { getToken } from "@/utils/auth";

const whiteList = ["/login", "/readme"];

router.beforeEach((to, from, next) => {
  if (getToken()) {
    next();
  } else {
    if (whiteList.includes(to.path)) {
      next();
    } else {
      // 不在白名单中的页面必须先登录再进入
      next("/login");
    }
  }
});
